/* EXODUS — theme behaviour (no dependencies) */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function playMuted(video) {
    if (!video || video.dataset.userPaused) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function initVideos(root) {
    root.querySelectorAll('video[data-autoplay]').forEach(function (v) {
      if (v.dataset.bound) return;
      v.dataset.bound = '1';
      ['loadedmetadata', 'canplay'].forEach(function (evt) {
        v.addEventListener(evt, function () { playMuted(v); });
      });
      playMuted(v);
    });
    root.querySelectorAll('[data-video-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-video-scope]') || document;
        var vids = scope.querySelectorAll('video[data-autoplay]');
        var pause = btn.getAttribute('aria-pressed') !== 'true';
        vids.forEach(function (v) {
          if (pause) { v.dataset.userPaused = '1'; v.pause(); }
          else { delete v.dataset.userPaused; playMuted(v); }
        });
        btn.setAttribute('aria-pressed', pause ? 'true' : 'false');
        btn.setAttribute('aria-label', pause ? 'Play background video' : 'Pause background video');
      });
    });
  }
  function initGallery(root) {
    root.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';
      var slides = gallery.querySelectorAll('[data-slide]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-thumb');
          slides.forEach(function (s) {
            var on = s.getAttribute('data-slide') === id;
            s.hidden = !on;
            if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
          });
          thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
        });
      });
    });
  }
  /* Buy once / Subscribe & save: writes the variant id + selling_plan into Shopify's product form */
  function initBuyBox(root) {
    root.querySelectorAll('[data-buybox]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var form = box.querySelector('form');
      var idInput = box.querySelector('[data-variant-input]');
      var planInput = box.querySelector('[data-plan-input]');
      var qtyWrap = box.querySelector('[data-qty]');
      var qtyInput = qtyWrap ? qtyWrap.querySelector('input') : null;
      var cta = box.querySelector('[data-cta]');
      var terms = box.querySelector('[data-terms]');
      var sticky = document.querySelector('[data-sticky-atc="' + box.id + '"]');
      var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
      var stickyBtn = sticky ? sticky.querySelector('[data-sticky-cta]') : null;
      function apply(radio) {
        if (!radio) return;
        idInput.value = radio.getAttribute('data-variant');
        var plan = radio.getAttribute('data-plan') || '';
        if (planInput) { planInput.value = plan; planInput.disabled = plan === ''; }
        if (qtyWrap) { qtyWrap.hidden = plan !== ''; if (plan !== '' && qtyInput) qtyInput.value = 1; }
        var label = radio.getAttribute('data-cta');
        var available = radio.getAttribute('data-available') === 'true';
        if (cta) { cta.textContent = available ? label : cta.getAttribute('data-soldout'); cta.disabled = !available; }
        if (terms) terms.innerHTML = radio.parentNode.querySelector('template[data-terms-copy]').innerHTML;
        if (stickyPrice) stickyPrice.textContent = radio.getAttribute('data-sticky');
        if (stickyBtn) { stickyBtn.textContent = available ? label : cta.getAttribute('data-soldout'); stickyBtn.disabled = !available; }
      }
      box.querySelectorAll('input[name="purchase_option"]').forEach(function (r) {
        r.addEventListener('change', function () { apply(r); });
      });
      apply(box.querySelector('input[name="purchase_option"]:checked'));
      document.querySelectorAll('[data-choose-plan]').forEach(function (link) {
        link.addEventListener('click', function () {
          var r = box.querySelector('input[name="purchase_option"][value="' + link.getAttribute('data-choose-plan') + '"]');
          if (r) { r.checked = true; apply(r); }
        });
      });
      if (sticky && 'IntersectionObserver' in window && cta) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var below = e.boundingClientRect.top > 0;
            sticky.classList.toggle('is-visible', !e.isIntersecting && !below);
          });
        }).observe(cta);
        if (stickyBtn && form) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(cta); else form.submit(); });
      }
    });
  }
  function initReveal(root) {
    var els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function init(root) { initVideos(root); initGallery(root); initBuyBox(root); initReveal(root); }
  ready(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();